import * as angular from "angular";
import { CampaignDataProvider } from "./campaign.dp";
import { CanvassDataProvider } from "./canvass.dp";
import { CanvasserTrackingDataProvider } from "./canvasser-tracking.dp";
import { CanvassStatusDataProvider } from "./canvass-status.dp";
import { CollectionPurposeDataProvider } from "./collection-purpose.dp";
import { ActivityDataProvider } from "./activity.dp";
import { DataSetDataProvider } from "./data-set.dp";
import { DivisionDataProvider } from "./division.dp";
import { DocumentDataProvider } from "./document.dp";
import { DuplicatesDataProvider } from "./duplicates.dp";
import { EffortDataProvider } from "./effort.dp";
import { ElectionDataProvider } from "./election.dp";
import { FieldDataProvider } from "./field.dp";
import { GroupDataProvider } from "./group.dp";
import { HouseDataProvider } from "./house.dp";
import { HouseOccupantDataProvider } from "./house-occupant.dp";
import { IntegrationDataProvider } from "./integration.dp";
import { InviteDataProvider } from "./invite.dp";
import { IssueDataProvider } from "./issue.dp";
import { LogsDataProvider } from "./logs.dp";
import { NationBuilderDataProvider } from "./nation-builder.dp";
import { NotificationDataProvider } from "./notification.dp";
import { OrganisationInviteDataProvider } from "./organisation-invite.dp";
import { OrganisationUserDataProvider } from "./organisation-user.dp";
import { PermissionCheck } from "../shared/permission";
import { PrivacyNoticeDataProvider } from "./privacy-notice.dp";
import { StreetDataProvider } from "./street.dp";
import { SurveyDataProvider } from "./survey.dp";
import { TalkingPointDataProvider } from "./talking-point.dp";
import { TeamDataProvider } from "./team.dp";
import { UserDataProvider } from "./user.dp";
import { VoterFileDataProvider } from "./voter-file.dp";
import { LimitDataProvider } from "./limit.dp";
import { IntegrationErrorsDataProvider } from "./integration-errors.dp";
import { BuildingDataProvider } from "./building.dp";
import { DashboardDataProvider } from "./dashboard.dp";
import { ProspectorDataProvider } from "./prospector.dp";

export class DataProvider {
    public readonly activityFeedTypes = [
        "house",
        "canvass",
        "houseoccupant",
        "voterfile",
        "queryemail",
        "rawemail",
        "document",
        "nbimport",
        "issue",
        "group",
        "team",
        "survey",
        "effort",
        "invite",
    ];
    public allDataProviders: object;
    private activityDataProvider: ActivityDataProvider;

    constructor(
        TeamDataProvider: TeamDataProvider,
        VoterFileDataProvider: VoterFileDataProvider,
        NotificationDataProvider: NotificationDataProvider,
        DocumentDataProvider: DocumentDataProvider,
        DataSetDataProvider: DataSetDataProvider,
        DivisionDataProvider: DivisionDataProvider,
        ActivityDataProvider: ActivityDataProvider,
        FieldDataProvider: FieldDataProvider,
        CanvassStatusDataProvider: CanvassStatusDataProvider,
        ElectionDataProvider: ElectionDataProvider,
        GroupDataProvider: GroupDataProvider,
        DashboardDataProvider: DashboardDataProvider,
        CampaignDataProvider: CampaignDataProvider,
        IssueDataProvider: IssueDataProvider,
        SurveyDataProvider: SurveyDataProvider,
        CanvasserTrackingDataProvider: CanvasserTrackingDataProvider,
        HouseDataProvider: HouseDataProvider,
        HouseOccupantDataProvider: HouseOccupantDataProvider,
        DuplicatesDataProvider: DuplicatesDataProvider,
        LogsDataProvider: LogsDataProvider,
        StreetDataProvider: StreetDataProvider,
        CanvassDataProvider: CanvassDataProvider,
        InviteDataProvider: InviteDataProvider,
        UserDataProvider: UserDataProvider,
        NationBuilderDataProvider: NationBuilderDataProvider,
        PermissionCheck: PermissionCheck,
        CollectionPurposeDataProvider: CollectionPurposeDataProvider,
        TalkingPointDataProvider: TalkingPointDataProvider,
        OrganisationInviteDataProvider: OrganisationInviteDataProvider,
        OrganisationUserDataProvider: OrganisationUserDataProvider,
        EffortDataProvider: EffortDataProvider,
        IntegrationDataProvider: IntegrationDataProvider,
        PrivacyNoticeDataProvider: PrivacyNoticeDataProvider,
        LimitDataProvider: LimitDataProvider,
        IntegrationErrorsDataProvider: IntegrationErrorsDataProvider,
        ProspectorDataProvider: ProspectorDataProvider,
        BuildingDataProvider: BuildingDataProvider
    ) {
        this.allDataProviders = {
            activity: ActivityDataProvider,
            team: TeamDataProvider,
            voterfile: VoterFileDataProvider,
            notification: NotificationDataProvider,
            document: DocumentDataProvider,
            dashboard: DashboardDataProvider,
            dataset: DataSetDataProvider,
            field: FieldDataProvider,
            election: ElectionDataProvider,
            group: GroupDataProvider,
            canvasstype: CampaignDataProvider,
            canvassstatus: CanvassStatusDataProvider,
            issue: IssueDataProvider,
            invite: InviteDataProvider,
            user: UserDataProvider,
            survey: SurveyDataProvider,
            canvass: CanvassDataProvider,
            house: HouseDataProvider,
            houseoccupant: HouseOccupantDataProvider,
            street: StreetDataProvider,
            duplicates: DuplicatesDataProvider,
            canvassertracking: CanvasserTrackingDataProvider,
            logs: LogsDataProvider,
            nationBuilder: NationBuilderDataProvider,
            permission: PermissionCheck,
            collectionpurpose: CollectionPurposeDataProvider,
            talking_point: TalkingPointDataProvider,
            organisation_invite: OrganisationInviteDataProvider,
            organisation_user: OrganisationUserDataProvider,
            effort: EffortDataProvider,
            integration: IntegrationDataProvider,
            privacy_notice: PrivacyNoticeDataProvider,
            division: DivisionDataProvider,
            integration_errors: IntegrationErrorsDataProvider,
            limit: LimitDataProvider,
            building: BuildingDataProvider,
            prospector: ProspectorDataProvider,
        };
        this.activityDataProvider = ActivityDataProvider;
    }

    clearAll(): void {
        angular.forEach(this.allDataProviders, (dataProvider: any) => {
            if (typeof dataProvider.clearAll === "function") {
                dataProvider.clearAll();
            }
        });
    }

    processSocketData(frame: any): void {
        if (this.allDataProviders[frame.type]) {
            if (frame.operation == "update") {
                if (this.allDataProviders[frame.type].processSocketUpdate) {
                    this.allDataProviders[frame.type].processSocketUpdate(
                        frame.data
                    );
                } else {
                    console.log(
                        "No processSocketUpdate for " +
                            frame.type +
                            " data provider"
                    );
                }
            } else if (frame.operation == "create") {
                if (this.allDataProviders[frame.type].processSocketCreate) {
                    this.allDataProviders[frame.type].processSocketCreate(
                        frame.data
                    );
                } else {
                    console.log(
                        "No processSocketCreate for " +
                            frame.type +
                            " data provider"
                    );
                }
            } else if (frame.operation == "delete") {
                if (this.allDataProviders[frame.type].processSocketDelete) {
                    this.allDataProviders[frame.type].processSocketDelete(
                        frame.data
                    );
                } else {
                    console.log(
                        "No processSocketDelete for " +
                            frame.type +
                            " data provider"
                    );
                }
            }
        }

        if (this.activityFeedTypes.indexOf(frame.type) > -1) {
            frame.data.atype = frame.type;
            if (frame.operation == "create") {
                //Activity data provider (processSocketCreate) push here.
                this.activityDataProvider.processSocketCreate(frame.data);
            }
        }
    }
}

angular.module("vcDataProvider").service("DataProvider", DataProvider);
